import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import compose from 'recompose/compose';
import SwipeableViews from 'react-swipeable-views';

// Material UI
import Drawer from '@mui/material/Drawer';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import IconButton from '@mui/material/IconButton';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

// Styles
import scss from './notification-sidenav.module.scss';

// Tabs
import NotificationsTab from './notifications-tab.component';

// Actions
import { toggleNotifications } from '../../../actions/layout.actions';

class NotificationSidenav extends React.Component {
    static propTypes = {
        layout: PropTypes.shape({
            notificationsOpen: PropTypes.bool,
        }),
        toggleNotifications: PropTypes.func,
    };

    static defaultProps = {
        layout: {
            notificationsOpen: false,
        },
        toggleNotifications: null,
    };

    state = {
        currentTabIndex: 0,
    };

    redirectToNotification = () => {
        window.location.href = '/notification';
    };

    handleChangeTab = (event, index) => {
        this.setState({ currentTabIndex: index });
    };

    handleChangeTabIndex = index => {
        this.setState({ currentTabIndex: index });
    };

    render() {
        const { layout } = this.props;

        return (
            <Drawer
                variant="temporary"
                open={layout.notificationsOpen}
                onClose={this.props.toggleNotifications}
                anchor="right"
                className={scss['portal-notification-sidenav']}
                PaperProps={{
                    style: {
                        width: '320px',
                    },
                }}
                ModalProps={{
                    keepMounted: true,
                }}
            >
                <AppBar color="default" position="static">
                    <Tabs
                        value={this.state.currentTabIndex}
                        onChange={this.handleChangeTab}
                        indicatorColor="primary"
                        textColor="primary"
                        fullWidth
                    >
                        <Tab label="Notifications" />
                    </Tabs>
                </AppBar>

                <SwipeableViews
                    className={scss['portal-notification-sidenav__content']}
                    index={this.state.currentTabIndex}
                    onChangeIndex={this.handleChangeTabIndex}
                >
                    <NotificationsTab />
                </SwipeableViews>

                <Toolbar disableGutters>
                    <IconButton onClick={this.props.toggleNotifications} className="bgBlue posAbsolute">
                        <ChevronRightIcon />
                    </IconButton>
                    <a
                        href=""
                        className="viewLink"
                        onClick={e => {
                            e.preventDefault();
                            this.props.toggleNotifications(e);
                            this.redirectToNotification();
                        }}
                    >
                        view all
                    </a>
                </Toolbar>
            </Drawer>
        );
    }
}

function mapStateToProps(state) {
    return {
        layout: {
            notificationsOpen: state.layout.notificationsOpen,
        },
    };
}

export default compose(
    connect(mapStateToProps, {
        toggleNotifications,
    }),
)(NotificationSidenav);
